<template>
  <div class="card doc-search-result">
    <div class="card-header">
      <div class="card-header-title">
        <b-icon pack="far" :icon="getIconFromContentType(result.contentType)" style="margin-right: 8px"></b-icon>
        <h5><a @click="download(result.filePath)" v-html="replaceFileNameWithHighlight(result)"></a></h5>
      </div>
    </div>
    <div class="card-content">
      <div class="result-filename"><span class="purple">{{result.fileName}}</span> <span class="has-text-grey-light">({{$numeral(result.fileSize).format('0.00b')}})</span></div>
      <p>{{result.description || 'No description provided.'}}</p>
    <br v-if="result.highlights && hasContentHighlights(result.highlights)">
    <!-- <div v-if="result.highlights && hasContentHighlights(result.highlights)" class="highlight">
      <h6 v-for="(hl, idx) in result.highlights.content" v-html="hl"></h6>
    </div> -->
    </div>
    
  </div>
</template>
<script>
export default {
  props: {
    result: Object
  },
  methods: {
    replaceFileNameWithHighlight(result) {
      // 1. If we have a title, use that
      if (result.title) {
        if (!result.highlights) return result.title;
        const highlight = result.highlights.title;
        return highlight?.length ? highlight[0] : result.title;
      }
      // 1. If we don't have a title, use filename
      if (!result.highlights) return result.fileName;
      const highlight = result.highlights.metadata_storage_name;
      return highlight?.length ? highlight[0] : result.fileName;
    },
    hasContentHighlights(highlights) {
      return (highlights.content);
    },
    getIconFromContentType(ct) {
      switch (ct) {
        case 'application/pdf':
          return 'file-pdf';
        case 'video/quicktime':
          return 'file-video';
        case 'image/jpeg':
        case 'image/png':
        case 'image/tiff':
          return 'file-image';
        case 'application/x-zip-compressed':
          return 'file-archive';
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'file-word';
        default:
          return 'file'
      }
    },
    isPdf(filePath) {
      return filePath.includes('.pdf');
    },
    async download(filePath) {
      // route the user to file download page
      this.$router.push({ name: 'downloadDocumentationFile', query: { path: filePath, view: this.isPdf(filePath) } });
      // bubble the event to clear the search results so the download/view initiates
      this.$emit('null-search');
    }
  }
}
</script>
<style lang="scss">
@import '../../styles/_colors';

.doc-search-result {
  margin-bottom: 1em;

  em {
    font-weight: 700;
    color: $orange;
    font-style: normal;
  }
}
</style>
<style lang="scss" scoped>
@import '../../styles/_colors';

.doc-search-result {

  .result-filename {
    margin-bottom: 8px;
    color: $grey;
  }

  .highlight {
    font-style: italic;

    h6 {
      padding: 5px 0;
      line-height: 1.25rem;

      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }

  em {
    font-weight: 700;
    color: $orange;
    padding: 0 3px;
    font-style: normal;
  }

  footer {
    //border-top: 1px solid $grey4;
    padding-top: 10px;
  }
}
</style>
